import React, { useState } from 'react';

export default function TagsEditor({ title = 'Edit Tags', selected = [], options = [], onSave, onClose, allowCustom = true }) {
  const [active, setActive] = useState([...selected]);
  const [customTag, setCustomTag] = useState('');

  const toggle = (tag) => {
    setActive(prev => prev.includes(tag) ? prev.filter(t => t !== tag) : [...prev, tag]);
  };

  const addCustom = () => {
    const tag = customTag.trim();
    if (tag && !active.includes(tag)) {
      setActive([...active, tag]);
    }
    setCustomTag('');
  };

  const handleSave = () => {
    onSave(active);
    onClose();
  };

  return (
    <div className="admin-modal-backdrop" onClick={onClose}>
      <div className="admin-modal" onClick={e => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3>{title}</h3>
          <button className="admin-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="admin-modal-body">
          <div className="admin-tags-grid">
            {options.map(tag => (
              <button
                key={tag}
                className={`admin-tag-option ${active.includes(tag) ? 'active' : ''}`}
                onClick={() => toggle(tag)}
              >
                {tag}
              </button>
            ))}
          </div>
          {allowCustom && (
            <div className="admin-custom-tag-row">
              <input
                type="text"
                placeholder="Custom tag..."
                value={customTag}
                onChange={e => setCustomTag(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addCustom(); } }}
                className="admin-input"
              />
              <button className="admin-btn-add" onClick={addCustom}>Add</button>
            </div>
          )}
          {active.length > 0 && (
            <div className="admin-selected-tags">
              <span className="admin-label">Selected:</span>
              {active.map(tag => (
                <span key={tag} className="admin-selected-tag">
                  {tag}
                  <button onClick={() => toggle(tag)} className="admin-tag-remove">×</button>
                </span>
              ))}
            </div>
          )}
        </div>
        <div className="admin-modal-footer">
          <button className="admin-btn-secondary" onClick={onClose}>Cancel</button>
          <button className="admin-btn-primary" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
}
